import type { FaireProductEntity } from "../../entity_types/product";

export const default_4: FaireProductEntity = {
  token: "default-4",
  type: "product",
  name: "Soy Candle - Vanilla & Sandalwood",
  brandName: "Scented Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/d43dcc7728200ede1ab8091ddb6892679895c784560376785908165e6232b9d9.webp",
  priceDollars: 19.5,
  msrpDollars: 34,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
